import React from "react"



export default function HeroParallax() {


    return (

        <section className="firstSection">
            <div className="container h-100">
                <div className="title h-100 d-flex justify-content-center flex-column">
                    <div>
                        <h1 className="d-flex justify-content-center ">
                            HEIMDALL Construction
                        </h1>
                    </div>
                    <div>
                        <h2 className="d-flex justify-content-center mt-3 mx-5">
                        Entreprise du Bâtiment, Travaux Services
                        et Maîtrise d’Œuvre d'exécution au service de vos projets de construction.
                        </h2>
                    </div>
                </div>
            </div>
        </section>
    );
}
